import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const MultiShipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RowListScroll = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/* Column widths aligned with row content for consistent alignment */
const ROW_GRID = {
  qty: '90px',
  gap: '12px',
  action: '44px',
};

export const Row = styled.div<{
  $compact?: boolean;
  $customGridTemplate?: string;
}>`
  display: grid;
  grid-template-columns: ${({ $customGridTemplate }) =>
    $customGridTemplate
      ? $customGridTemplate // Custom template provided by parent component, e.g. "Qty | Address | Price | Delete"
      : `${ROW_GRID.qty} 1fr ${ROW_GRID.action}`}; // Qty | Address | Delete
  gap: ${({ $compact }) => ($compact ? '8px' : ROW_GRID.gap)};
  align-items: center;
  flex-shrink: 0;
  min-height: 52px;

  select {
    padding: 8px;
  }

  button {
    background: transparent;
    border: 1px solid ${DEFAULT_COLORS.sky.lighter};
    padding: 6px 10px;
    cursor: pointer;
  }
`;

export const RowQtyCell = styled.div`
  display: flex;
  align-items: center;
`;

export const RowAddressCell = styled.div`
  min-width: 0;
  width: 100%;
`;

export const RowActionCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const AddMoreWrapper = styled.div`
  flex-shrink: 0;
  padding-top: 4px;
  border-top: 1px solid ${DEFAULT_COLORS.surface.hover};
  margin-top: 4px;
`;

export const AddMore = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: ${DEFAULT_COLORS.accent.primaryAlt};
  max-width: 200px;
  cursor: pointer;
  padding: 0;
  text-align: left;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: ${DEFAULT_COLORS.grey50};
    cursor: not-allowed;
  }
`;

export const AddMoreError = styled.div`
  font-size: 12px;
  color: ${DEFAULT_COLORS.accent.coral};
  margin-top: 6px;
  line-height: 1.4;
`;

export const UnitPriceCell = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  color: ${DEFAULT_COLORS.grey70};
`;

export const PriceCell = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: ${DEFAULT_COLORS.grey87};
`;
